import React from 'react';
// import airSlate from '../../img/pc/airSlate.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // speakers: [
      //   {
      //     photo: Dalal,
      //     name: 'Sunil Dalal',
      //     position: 'Sr. Software Engineer',
      //     ln: 'https://www.linkedin.com/in/sunieldalal/',
      //     logo: Netflix,
      //   },
      //   {
      //     photo: Schutten,
      //     name: 'Rolf Schutten',
      //     position: 'Cloud Advocate',
      //     ln: 'https://www.linkedin.com/in/rolf-schutten/',
      //     logo: Cegeka,
      //   },
      //   {
      //     photo: Maheshwar,
      //     name: 'Sohan Maheshwar',
      //     position: 'Senior Developer Advocate',
      //     ln: 'http://linkedin.com/in/sohanmaheshwar/',
      //     logo: aws,
      //   },
      //   {
      //     photo: Yudovin,
      //     name: 'Artsiom Yudovin',
      //     position: `Data Engineer's Lead/Architect`,
      //     ln: 'https://www.linkedin.com/in/artsiom-yudovin-14260011b/',
      //     logo: airSlate,
      //   },
      //   {
      //     photo: Apel,
      //     name: 'Oded Apel',
      //     position: 'Architect',
      //     ln: 'https://www.linkedin.com/in/oded-apel-61373887/',
      //     logo: Capgemini,
      //   },
      //   {
      //     photo: Richardson,
      //     name: 'Rob Richardson',
      //     position: 'Developer Advocate',
      //     ln: 'https://www.linkedin.com/in/erobrich/',
      //     tw: 'https://twitter.com/rob_rich',
      //     github: 'https://github.com/robrich',
      //     logo: Jetpackio,
      //   },
      //   {
      //     photo: Florentino,
      //     name: 'Vinicius Florentino',
      //     position: 'Specialist Solution Architect',
      //     ln: 'https://www.linkedin.com/in/viniciusfcf',
      //     tw: 'https://twitter.com/viniciusfcf',
      //     logo: RedHat,
      //   },
      //   {
      //     photo: Gupta,
      //     name: 'Rahul Gupta',
      //     position: 'Architect',
      //     ln: 'https://www.linkedin.com/in/rahul-g-08aa985/',
      //     logo: Microsoft,
      //   },
      // ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}